import { render, staticRenderFns } from "./divide.vue?vue&type=template&id=e4dda5c4&scoped=true&"
import script from "./divide.vue?vue&type=script&lang=ts&"
export * from "./divide.vue?vue&type=script&lang=ts&"
import style0 from "./divide.vue?vue&type=style&index=0&id=e4dda5c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dda5c4",
  null
  
)

export default component.exports